export default __webpack_public_path__ + "static/media/2320.3c294df1.png";